import { css } from 'styled-components';
export const set = (justifyContent, alignItems, direction) => css `
  ${alignItems && `align-items: ${alignItems};`}
  display: flex;
  ${direction && `flex-direction: ${direction};`}
  ${justifyContent && `justify-content: ${justifyContent};`}
`;
export const setColumn = (justifyContent, alignItems) => css `
  ${set(justifyContent, alignItems, 'column')}
`;
export const center = (direction) => css `
  ${set('center', 'center', direction)}
`;
export const centerColumn = () => css `
  ${set('center', 'center', 'column')}
`;
//# sourceMappingURL=flex.js.map